import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import Layout from 'components/Layout';
import { useBookings } from 'core/contexts/booking';
import { useTranslation } from 'core/contexts/localization';
import { CircularProgress, useMediaQuery } from '@mui/material';
import { toast } from 'react-toastify';
import { useStyles } from './styles';
import { BookingPageComponentLegacy } from '@utriper/core-ui';
import { BookingStatus } from '@utriper/core';
import { ScheduleService } from 'core/api/services/schedule';
import { EntityService } from 'core/api/services/lookUp';
import { PreviewService } from 'core/api/services/preview';
import { BookingResourceService } from 'core/api/services/bookingResource';

const BookingPage = () => {
    const classes = useStyles();
    const { t: translate } = useTranslation();
    const { getBooking, updateBooking, booking, loading, setBooking } = useBookings();
    const [originalBooking, setOriginalBooking] = useState({});
    const [canEdit, setCanEdit] = useState(false);
    const [isCancel, setIsCancel] = useState(false);
    const [isPending, setIsPending] = useState(BookingStatus.IDS.pending === originalBooking.status);
    const [hasChanged, setHasChanged] = useState(false);

    const locationParam = document.location.href.split('/');
    const bookingIndex = locationParam[locationParam.length - 1];

    useEffect(() => {
        setBooking({});
        if (bookingIndex == 0) {
            setCanEdit(true);
        } else {
            getBooking(bookingIndex);
        }
    }, []);

    useEffect(() => {
        // We do this to be able to cancel and revert unsaved changes
        if (!originalBooking.id || originalBooking.id !== booking.id) {
            const auxBooking = {
                ...booking,
            };
            setOriginalBooking(auxBooking);
            setIsPending(BookingStatus.IDS.pending === auxBooking.status);
        }
        if (parseInt(booking.status) === BookingStatus.IDS.cancelled) {
            setIsCancel(true);
        } else {
            setIsCancel(false);
        }
    }, [booking]);

    const onSave = async (values) => {
        try {
            // values = { experiencer: userInfo };
            const valuesClon = { ...values };
            const res = await updateBooking(valuesClon);
            if (res) {
                toast.success('Booking updated!', {
                    position: 'top-right',
                    theme: 'colored',
                });
            }
            getBooking(bookingIndex);
            setOriginalBooking(booking);
            setIsPending(BookingStatus.IDS.pending === booking.status);
        } catch (err) {
            toast.error(err, {
                position: 'top-right',
                theme: 'colored',
            });
        }
    };

    const onCancel = () => {
        setBooking(originalBooking);
    };

    const handleAddResource = async ({ idBkg, idRes }) => {
        try {
            const result = await BookingResourceService.addResource(parseInt(idBkg), parseInt(idRes));
            if (result) {
                toast.success(translate('resource.resource_added_success'), {
                    position: 'top-right',
                    theme: 'colored',
                });
                getBooking(bookingIndex);
            }
        } catch (error) {
            toast.error(error.message, {
                position: 'top-right',
                theme: 'colored',
            });
        }
    };

    const handleDeleteResource = async ({ idBkg, idBkgRes }) => {
        try {
            const result = await BookingResourceService.deleteResource(parseInt(idBkg), parseInt(idBkgRes));
            if (result) {
                toast.success(translate('resource.resource_removed_success'), {
                    position: 'top-right',
                    theme: 'colored',
                });
                getBooking(bookingIndex);
            }
        } catch (error) {
            toast.error(error.message, {
                position: 'top-right',
                theme: 'colored',
            });
        }
    };

    return (
        <Layout>
            {/* <Title value={'Booking'} /> */}
            <div>
                {loading ? (
                    <CircularProgress />
                ) : (
                    // STARTS BOOKING INFO
                    <div className={classes.content}>
                        <BookingPageComponentLegacy
                            booking={booking}
                            setBooking={setBooking}
                            canEdit={true}
                            isEditable={true}
                            hasChanged={hasChanged}
                            setHasChanged={setHasChanged}
                            entityService={EntityService}
                            onSave={onSave}
                            onCancel={onCancel}
                            addBookingResource={handleAddResource}
                            deleteBookingResource={handleDeleteResource}
                            paymentLinkURL={process.env.REACT_APP_UTRIPER_BUY_URL}
                            fileUrl={process.env.REACT_APP_CDN_URL}
                            accionButtons={{
                                setDate: {
                                    show: !isCancel,
                                },
                                setNoShow: {
                                    show: !isCancel,
                                },
                                setCancel: {
                                    show: !isCancel,
                                },
                                setConfirm: {
                                    show: isPending,
                                },
                            }}
                            showTriper={true}
                            showResources={true}
                            getAvailability={ScheduleService.getAvailability}
                            previewService={PreviewService}
                            translate={translate}
                        />
                    </div>
                    // ENDS BOOKING INFO
                )}
            </div>
        </Layout>
    );
};

BookingPage.displayName = 'BookingPage';

export default BookingPage;
